import { useState, useEffect } from 'react';
import { useContextoSesion } from '../../miscelaneo/ContextoSesion';
import { FaCashRegister, FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function Navbar({ onToggleMenu = () => {} }) {
  const { usuario, sesionCaja } = useContextoSesion();
  const navigate = useNavigate();

  // Tick cada 60s para actualizar el tiempo en pantalla
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!sesionCaja) return;
    const id = setInterval(() => setTick(t => t + 1), 60_000);
    return () => clearInterval(id);
  }, [sesionCaja]);

  // Calcular tiempo abierta usando segundos_abierta del servidor
  // (evita desfase de timezone entre DB y navegador)
  const tiempoAbierta = () => {
    if (!sesionCaja?.segundos_abierta) return '';
    const segundosBase = parseFloat(sesionCaja.segundos_abierta);
    const segundosLocales = sesionCaja._fetchedAt
      ? (Date.now() - sesionCaja._fetchedAt) / 1000
      : 0;
    const diff = Math.floor(segundosBase + segundosLocales);
    const horas = Math.floor(diff / 3600);
    const minutos = Math.floor((diff % 3600) / 60);
    if (horas > 0) return `${horas}h ${minutos}m`;
    return `${minutos}m`;
  };

  return (
    <header className="bg-color-primario text-white p-3 md:p-4 shadow-md rounded-xl mt-2 mx-1">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <button
            onClick={onToggleMenu}
            className="md:hidden p-2 -ml-1 rounded-lg hover:bg-white hover:bg-opacity-20"
            aria-label="Abrir menú"
          >
            <FaBars size={20} />
          </button>
          <h1 className="text-xl font-bold">OmniERP</h1>
        </div>
        
        <div className="flex items-center gap-2 md:gap-4">
          {/* Indicador de caja abierta */}
          {sesionCaja && (
            <button
              onClick={() => navigate('/CierreCaja')}
              className="flex items-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-1.5 rounded-lg transition-all duration-200 text-sm"
              title="Click para ir a cerrar caja"
            >
              <FaCashRegister className="text-green-300" />
              <span className="hidden md:inline font-medium">{sesionCaja.nombre_caja}</span>
              <span className="text-xs text-green-200">{tiempoAbierta()}</span>
            </button>
          )}

          {/* Nombre de usuario */}
          {usuario && (
            <div className="flex items-center gap-2 text-sm">
              <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                <span className="font-semibold">
                  {usuario.nombre?.charAt(0)?.toUpperCase() || 'U'}
                </span>
              </div>
              <span className="hidden md:inline">
                {usuario.nombre} {usuario.apellido || ''}
              </span>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
